export enum MediaWidth {
  sm = 576,
  md = 768,
  lg = 1025,
  xl = 1200,
  xxl = 1600,
}
